import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexGrow: 1
  }
}));


export default function Version() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <p>
        Env:
        {process.env.REACT_APP_ENV}
      </p>
      <p>
        Hash:
        {process.env.REACT_APP_SHA}
      </p>
      <p>
        Version:
        {process.env.REACT_APP_VERSION}
      </p>
    </div>
  );
}
